import { morphdomCopyPreservedAttributes } from "web-ui/morphdom/preserve-attributes"
import { morphdomShouldUpdate } from "web-ui/morphdom/should-update"
import { isMorphdomIgnored } from "web-ui/morphdom/ignore"

export function buildOptions(customOptions = {}) {
  const options = {
    getNodeKey: (node) => {
      if (node) {
        let key = (node.getAttribute && node.getAttribute('id')) || node.id;

        // The combination of morphdom and tom-select require that we properly
        // match options so that the individual option value does not change
        // during a morph. If it does, and an automated test is attempting to
        // select that option, it may inadvertently select a different option.
        // Combining the parent ID with the node's value is important because
        // these keys are considered unique across the entire document.
        // - Aaron, Fri Dec 5 2025
        if (!key && node instanceof HTMLOptionElement) {
          const parentId = node.parentElement.id

          if (parentId) {
            key = `${parentId}-${node.value}`
          }
        }

        return key
      }
    },

    onBeforeElUpdated: (fromElement, toElement) => {
      morphdomCopyPreservedAttributes(fromElement, toElement)

      return morphdomShouldUpdate(fromElement, toElement)
    },

    onBeforeNodeDiscarded: (node) => {
      if (!(node instanceof HTMLElement)) {
        return true
      }

      // Do not remove elements that indicate they should be ignored
      if (isMorphdomIgnored(node)) {
        return false
      }

      return true
    },

    onElUpdated: (element) => {
      element.dispatchEvent(new CustomEvent("morphdom:updated", { bubbles: false }))
    },

    ...customOptions
  }

  return options
}
